var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"input-delta-text"},[_c('div',{ref:"delta"})])}
var staticRenderFns = []

export { render, staticRenderFns }